import { SuperSdk } from '@concordia/super-sdk'

export interface SdkContext {
  superSdk: SuperSdk
}

export const SDK_CONTEXT: SdkContext = {
  superSdk: new SuperSdk(process.env.REACT_APP_SUPER_JSON_API_URL)
}
